export const FORMS_CONFIG_OVERRIDE = {};
